module.exports = __webpack_public_path__ + "img/photo-34.109e33ed.webp";